import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

export default function SupportSuccess() {
  const [searchParams] = useSearchParams();
  const [verified, setVerified] = useState(false);
  const [loading, setLoading] = useState(true);

  const transaction_id = searchParams.get("transaction_id");

  useEffect(() => {
    const verifyPayment = async () => {
      if (!transaction_id) {
        setLoading(false);
        return;
      }

      try {
        const res = await fetch(
          `https://creator-mvp-hvdx.onrender.com/support/verify?transaction_id=${transaction_id}`
        );

        const data = await res.json();

        if (data.status === "success") {
          setVerified(true);
        }
      } catch (err) {
        console.error("Verification error:", err);
      } finally {
        setLoading(false);
      }
    };

    verifyPayment();
  }, [transaction_id]);

  if (loading) {
    return <h2 style={{ textAlign: "center" }}>Verifying... ⏳</h2>;
  }

  if (!verified) {
    return (
      <div style={{ textAlign: "center", padding: 40 }}>
        <h1>⏳ Payment pending</h1>
        <p>Refresh in a few seconds</p>
      </div>
    );
  }

  return (
    <div style={{ textAlign: "center", padding: 40 }}>
      <h1>✅ Support Successful</h1>
      <p>Creator has received your support 🙌</p>
    </div>
  );
}